import {
  Box,
  Container,
  Typography
} from '@mui/material';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { subWeeks, startOfWeek, endOfWeek } from 'date-fns';
import FiltersBar from '../components/FiltersBar.jsx';
import EquipesProdutividadeTable from '../components/tables/EquipesProdutividadeTable';

const EquipesAlertas = () => {
  // Calcular última semana como padrão
  const defaultLastWeek = useMemo(() => {
    const semanaAnterior = subWeeks(new Date(), 1);
    return {
      inicio: startOfWeek(semanaAnterior, { weekStartsOn: 0 }),
      fim: endOfWeek(semanaAnterior, { weekStartsOn: 0 })
    };
  }, []);

  // Estados dos filtros
  const [pendingContrato, setPendingContrato] = useState([]);
  const [pendingCentro, setPendingCentro] = useState([]);
  const [pendingEquipe, setPendingEquipe] = useState([]);
  const [pendingStartDate, setPendingStartDate] = useState(defaultLastWeek.inicio);
  const [pendingEndDate, setPendingEndDate] = useState(defaultLastWeek.fim);

  // Estados dos filtros reais (usados para buscar dados)
  const [contrato, setContrato] = useState([]);
  const [centro, setCentro] = useState([]);
  const [equipe, setEquipe] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [periodoSelecionado, setPeriodoSelecionado] = useState('ultima-semana');
  const [loadCounter, setLoadCounter] = useState(0); // Contador para forçar refetch

  const handleCarregar = useCallback(() => {
    setContrato(pendingContrato);
    setCentro(pendingCentro);
    setEquipe(pendingEquipe);
    setStartDate(pendingStartDate);
    setEndDate(pendingEndDate);
    setIsFirstLoad(false);
    setLoadCounter(prev => prev + 1); // Incrementa contador para forçar refetch
  }, [pendingContrato, pendingCentro, pendingEquipe, pendingStartDate, pendingEndDate]);

  // Auto-carregar quando todos os filtros forem preenchidos pela primeira vez
  const autoLoaded = useRef(false);
  useEffect(() => {
    if (pendingContrato.length > 0 && pendingCentro.length > 0 && pendingEquipe.length > 0 && pendingStartDate && pendingEndDate && !autoLoaded.current) {
      autoLoaded.current = true;
      handleCarregar();
    }
  }, [pendingContrato, pendingCentro, pendingEquipe, pendingStartDate, pendingEndDate, handleCarregar]);

  return (
    <Container maxWidth="xl" sx={{ mb: 4, px: { xs: 1, sm: 2, md: 3 } }}>
      <Box sx={{ mb: { xs: 2, sm: 4 } }}>
        <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>
          Alertas
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          Identifique rapidamente inconsistências, riscos operacionais e ações recomendadas.
        </Typography>
      </Box>

      <FiltersBar
        contrato={pendingContrato}
        setContrato={setPendingContrato}
        centro={pendingCentro}
        setCentro={setPendingCentro}
        equipe={pendingEquipe}
        setEquipe={setPendingEquipe}
        startDate={pendingStartDate}
        setStartDate={setPendingStartDate}
        endDate={pendingEndDate}
        setEndDate={setPendingEndDate}
        onCarregar={handleCarregar}
        periodoSelecionado={periodoSelecionado}
        onPeriodoChange={setPeriodoSelecionado}
        periodoSelecionadoProp="ultima-semana"
      />

      {/* Tabela de Produtividade por Equipe */}
      {!isFirstLoad && contrato.length > 0 && (
        <EquipesProdutividadeTable
          periodoSelecionado={periodoSelecionado}
          contrato={contrato}
          centro={centro}
          equipe={equipe}
          startDate={startDate}
          endDate={endDate}
          loading={false}
          refreshKey={loadCounter}
        />
      )}

    </Container>
  );
};

export default EquipesAlertas;

